import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OfferLinkComponent } from './components';
import { MarketingMainComponent } from './containers';


const routes: Routes = [
  {
  path: '',
  component: MarketingMainComponent,
  children: [
    { path: 'offer-link', component: OfferLinkComponent  }
  ]
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MarketingRoutingModule {}
